// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"265":"datepicker2","440":"datepicker2range"}[chunkId] + ".js";
};